import React, {useState} from "react";
import RenderOnRole from "../../RenderOnRole";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ProjectObjects from "./ProjectObjects";
import ProjectObjectsSelect from "./ProjectObjectsSelect";
import PropTypes from "prop-types";
import ProjectUsers from "./ProjectUsers";
import BimProjectFormList from "./BimProjectFormList";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const TabBorderStyle = {
    padding: "3px",
    borderRight: "1px solid black",
    borderTop: "1px solid black",
    borderLeft: "1px solid black",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
};

function BimProjectTabs({users, bimProjectData, checkedRights, handleChange, realm,
                            setProfileId, profileId, optionsRealestateobject,
                            setSelectedRealestateobject, selectedRealestateobject, setHideSaveButton}) {
    const [value, setValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
        setHideSaveButton(newValue > 1);
    };

    return (
        <RenderOnRole roles={['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN']}>
            {bimProjectData.guid ? (
                <>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: '10px'}}>
                        <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example" sx={{marginLeft: '5px' }}>
                            <Tab label="Projekt" {...a11yProps(0)} sx={TabBorderStyle}/>
                            <Tab label="Benutzer" {...a11yProps(1)} sx={TabBorderStyle}/>
                            <Tab label="Objekte" {...a11yProps(2)} sx={TabBorderStyle} />
                            <Tab label="Objekte zuordnen" {...a11yProps(3)} sx={TabBorderStyle}/>
                        </Tabs>
                    </Box>
                    <TabPanel value={value} index={0}>
                        <BimProjectFormList
                            bimProjectData={bimProjectData}
                            setProfileId={setProfileId}
                            profileId={profileId}
                            optionsRealestateobject={optionsRealestateobject}
                            setSelectedRealestateobject={setSelectedRealestateobject}
                            selectedRealestateobject={selectedRealestateobject}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <ProjectUsers users={users}
                                      checkedRights={checkedRights}
                                      handleChange={handleChange}
                                      realm={realm}
                                      />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <ProjectObjects projectGuid={bimProjectData.guid} realm={realm}
                                        projectId={bimProjectData.id}/>
                    </TabPanel>
                    <TabPanel value={value} index={3} >
                        <ProjectObjectsSelect projectGuid={bimProjectData.guid} realm={realm}
                                              projectId={bimProjectData.id}/>
                    </TabPanel>
                </>
            ) : (
                <BimProjectFormList
                    bimProjectData={bimProjectData}
                    setProfileId={setProfileId}
                    profileId={profileId}
                    optionsRealestateobject={optionsRealestateobject}
                    setSelectedRealestateobject={setSelectedRealestateobject}
                    selectedRealestateobject={selectedRealestateobject}
                />
            )}
        </RenderOnRole>
    );
}

export default BimProjectTabs;
